import { useRef, useEffect } from 'react';

function useIsInitialRender() {
  const isMountRef = useRef(true);

  useEffect(() => {
    isMountRef.current = false;
  }, []);

  return isMountRef.current;
}

export default useIsInitialRender;
